<template>
  <vue-modal no-close ref="modal">
    <!-- <template v-slot:header>
      <div class="p-3 bg-dark fw-600 text-white text-center">
      </div>
    </template> -->
    <template v-slot:default>
      <div v-if="loading">
        <div class="loading-shade"></div>
        <pre-loader></pre-loader>
      </div>
        <div class="container-modal">
          <div class="text">Please be aware that in the event of company insolvency, customer funds are not protected.</div>
        </div>
        <vue-button 
          type="button"
          @click="submitForm"
          cls="main">Message Acknowleged</vue-button>
    </template>
  </vue-modal>
</template>

<script>
import { mapGetters } from "vuex";
import PreLoader from "@/components/UI/PreLoader";
import VueModal from "@/components/UI/VueModal";
import VueButton from "@/components/UI/VueButton";

export default {
  name: "InsolvencyModal",
  components: {
    PreLoader,
    VueModal,
    VueButton,
  },
  data: () => {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['USER']),
  },
  watch: {
    'USER.displayInsolvencyModal'() {
      this.initPopupState()
    }
  },
  mounted() {
    this.initPopupState()
  },
  methods:{
    initPopupState() {
      if (this.USER?.displayInsolvencyModal) {
        this.$refs.modal.open()
      }
      else{
        this.close()
        this.loading = false;
      }
    },
    submitForm() {
      this.loading = true;
      
      this.API.postInsolvency()
        .then(resp => {
          if (!resp?.isFormSent) {
            this.$toast.error('Something went wrong. Please try again later')
            this.loading = false;
          }
          
        })
        .catch(er => {
          this.$toast.error('Something went wrong. Please try again later')
          console.log('postInsolvency ERROR', er)
          this.loading = false;
        })
        .finally(() => {
          //reload user info
          this.$store.dispatch('GET_USER_INFO')
        })
    },
    close() {
      this.$refs.modal.close()
    }

  }
}
</script>

<style scoped lang="scss">
  .content{
    max-width: 400px;
  }

  .container-modal {
    margin: 0;
    max-width: 60vw;
    @media only screen and (max-width: 1024px){
      max-width: unset;
    }

    .text {
      margin-bottom: 2.5rem;
      text-align: center;
    }
  }
</style>